<template>
  <b-form class="mt-3" @submit="onSubmitForm">
    <b-row>
      <b-col cols="12" md="6">
        <InputFilter :filter="search[0]" />
      </b-col>
      <b-col cols="12" md="6">
        <InputFilter :filter="search[1]" />
      </b-col>
      <b-col cols="12" md="6">
        <InputFilter :filter="search[2]" />
      </b-col>
      <b-col cols="12" md="6">
        <InputFilter :filter="search[3]" />
      </b-col>
      <b-col cols="12" md="6">
        <InputFilter :filter="search[4]" />
      </b-col>
      <b-col cols="12" md="6">
        <InputFilter :filter="search[5]" />
      </b-col>
      <b-col cols="12" md="3">
        <InputFilter :filter="search[6]" />
      </b-col>
      <b-col cols="12" md="3">
        <InputFilter :filter="search[7]" />
      </b-col>

      <!-- TEST SELECT -->
    </b-row>

    <!-- Action Buttons -->
    <div class="text-center pt-1">
      <b-button
        variant="primary"
        class="mb-1 mb-sm-0 mr-0 mr-sm-1"
        type="submit"
      >
        ค้นหา
      </b-button>
      <b-button
        variant="outline-secondary"
        type="reset"
        @click="onResetBtnClicked"
      >
        ล้าง
      </b-button>
    </div>
  </b-form>
</template>

<script>
import {
  BButton,
  BAvatar,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BForm,
  BFormCheckbox,
} from "bootstrap-vue";
import vSelect from "vue-select";
import InputFilter from "../../../filters/components/InputFilter.vue";

export default {
  components: {
    BButton,
    BAvatar,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BForm,
    BFormCheckbox,
    vSelect,
    InputFilter,
  },
  props: {
    mode: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    const searchList = [
      {
        id: "issueObj",
        label: "วัตถุประสงค์เรื่อง",
        value: "",
        class: "",
        style: "",
        placeholder: "วัตถุประสงค์เรื่อง",
        type: "text",
        options: [],
      },
      {
        id: "issueId",
        label: "รหัสเรื่อง",
        value: "",
        class: "",
        style: "",
        placeholder: "รหัสเรื่อง",
        type: "text",
        options: [],
      },
      {
        id: "issueType",
        label: "ประเภทเรื่อง",
        value: "",
        class: "",
        style: "",
        placeholder: "ประเภทเรื่อง",
        type: "text",
        options: [],
      },
      {
        id: "complaintTopic",
        label: "หัวข้อร้องทุกข์",
        value: "",
        class: "",
        style: "",
        placeholder: "หัวข้อร้องทุกข์",
        type: "text",
        options: [],
      },
      {
        id: "complaintDetail",
        label: "รายละเอียดคำร้อง",
        value: "",
        class: "",
        style: "",
        placeholder: "รายละเอียดคำร้อง",
        type: "text",
        options: [],
      },
      // {
      //   id: "value",
      //   label:
      //     "วัตถุประสงค์เรื่อง / รหัสเรื่อง / ประเภทเรื่อง / หัวข้อร้องทุกข์ / สถานะระบบร้องทุกข์",
      //   value: "",
      //   class: "",
      //   style: "",
      //   placeholder:
      //     "วัตถุประสงค์เรื่อง / รหัสเรื่อง / ประเภทเรื่อง / หัวข้อร้องทุกข์ / สถานะระบบร้องทุกข์",
      //   type: "text",
      //   options: [],
      // },
      {
        id: "petitioner",
        label: "ชื่อผู้ร้อง",
        value: "",
        class: "",
        style: "",
        placeholder: "ชื่อผู้ร้อง",
        type: "text",
        options: [],
      },
      {
        id: "receiveStartDate",
        label: "ช่วงเวลาที่รับเรื่อง",
        value: "",
        class: "",
        style: "",
        placeholder: "",
        type: "date",
        options: [],
      },
      {
        id: "receiveEndDate",
        label: "ถึง",
        value: "",
        class: "",
        style: "",
        placeholder: "",
        type: "date",
        options: [],
      },
    ];
    return {
      search: searchList,
      props,
    };
  },
  mounted() {
    this.onSearchBtnClicked();
  },
  methods: {
    onSubmitForm(e) {
      e.preventDefault();
      this.onSearchBtnClicked();
    },
    onResetBtnClicked() {
      this.search.forEach(item => {
        item.value = null;
      });
      // this.search[0].value = null;
    },
    onSearchBtnClicked() {
      const params = {
        issueObj: this.search[0].value,
        issueId: this.search[1].value,
        issueType: this.search[2].value,
        complaintTopic: this.search[3].value,
        complaintDetail: this.search[4].value,
        petitioner: this.search[5].value,
        receiveStartDate: this.search[6].value,
        receiveEndDate: this.search[7].value,       
      };
      this.$emit("handleSubmit", params);
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
